import { IEventsStore } from '../../events'

export default function(state: IEventsStore): IEventsStore {
  delete state['events']
  return {
    ...state,
    events: [],
  }
}
